export enum HdisFormFieldBulkOperations {
  Clean = 'HDIS_FORM_FIELD_BULK_CLEAN',
  Keep = 'HDIS_FORM_FIELD_BULK_KEEP',
}
